import React from 'react';

import { useIsBreakpointSize } from 'app/shared/utils/useBreakpoint';
import { VideosPageVideo } from 'app/shared/typings';
import { Grid, GridItem, LoadingBlock } from 'app/shared/components/atoms';
import { BasePageBox } from 'app/shared/components/molecules';

import { VideoThumbnail } from './VideoThumbnail';

export interface VideoThumbnailsGridProps {
  videos: VideosPageVideo[];
  videosLoading: boolean;
  resultsPerPage?: number;
}

export const VideoThumbnailsGrid: React.FC<
  React.PropsWithChildren<VideoThumbnailsGridProps>
> = ({ videos, videosLoading, resultsPerPage = 12 }) => {
  const { isDesktop } = useIsBreakpointSize();
  const loadingBlockHeight = isDesktop ? '200px' : '300px';

  const gridItemProps = {
    mobile: 12,
    tablet: 6,
    smallDesktop: 4,
    largeDesktop: 3,
  };

  const numLoadingBlocks = Math.min(resultsPerPage, 12);

  if (videosLoading) {
    return (
      <BasePageBox>
        <Grid gap={5} data-qaid="loading-blocks">
          {Array.from(Array(numLoadingBlocks).keys()).map((index) => (
            <GridItem {...gridItemProps} key={index}>
              <LoadingBlock w="100%" h={loadingBlockHeight} mt={8} />
            </GridItem>
          ))}
        </Grid>
      </BasePageBox>
    );
  }

  if (!videos) {
    return null;
  }

  return (
    <BasePageBox>
      <Grid gap={5} data-qaid="video-thumbnails-grid">
        {videos.map((video: VideosPageVideo) => (
          <GridItem {...gridItemProps} key={video.id}>
            <VideoThumbnail video={video} />
          </GridItem>
        ))}
      </Grid>
    </BasePageBox>
  );
};
